import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bedingungen',
  templateUrl: './bedingungen.component.html',
  styleUrls: ['./bedingungen.component.scss']
})
export class BedingungenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
